import React from 'react';
import { Reveal } from './Reveal';
import { PricingCards } from './PricingCards';
export function PricingSection() {
  return <section id="pricing" aria-label="Elegí tu opción" className="w-full bg-cream-200 py-16 sm:py-24" data-id="element-150" data-mp="19jxenin1zhdz">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-151" data-mp="1egnt61j7m4xa">
        <Reveal data-id="element-152" data-mp="1j8p3vj0qbnl7">
          <h2 className="text-center font-display text-3xl font-semibold tracking-tight text-bark-900 sm:text-4xl" data-id="element-153" data-mp="1j978p41gja4q">
            Elegí cómo querés empezar
          </h2>
        </Reveal>
        <div className="mt-10" data-id="element-154" data-mp="1s93yj8zl2f1d">
          <PricingCards highlightId="kit-completo" data-id="element-155" data-mp="1s8c6g8572zfu" />
        </div>
      </div>
    </section>;
}